<template>
  <div>
    <div v-if="show_form" style="text-align: right;" dir="rtl">
      <div>
        <p class="bold">Title</p>
        <input class="outlined" v-model="title">
      </div>
      <div>
        <p class="bold">Content</p>
        <textarea class="outlined" v-model="content"></textarea>
      </div>
      <div>
        <p class="bold">Response to comment id</p>
        <input class="outlined" v-model="response_to_comment_id">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'developer-interview-article-comment',
  data () {
    return {
      is_loading: false,
      show_form: false,
      title: '',
      content: '',
      response_to_comment_id: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.show_form = true
        return
      }
      axios.request({
        method: 'get',
        url: `http://64.225.73.88:9078/comments/${this.payload.data.id}`
      }).then(response => {
        this.title = response.data.title
        this.content = response.data.content
        this.response_to_comment_id = response.data.response_to_comment_id
        this.show_form = true
      })
    },
    submit () {
      let method = this.payload.is_create ? 'post' : 'put'
      axios.request({
        method,
        url: `http://64.225.73.88:9078/comments/${this.payload.is_create ? '' : this.payload.data.id}`,
        data: {
          title: this.title,
          content: this.content,
          response_to_comment_id: this.response_to_comment_id,
          article_id: this.payload.article_id
        }
      }).then(() => {
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
